module.exports = __webpack_public_path__ + "static/media/ic_close_white.7df0f151.svg";